import { MapPin, CalendarCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#00334a] text-[#f8f3e9] border-t border-white/10">
      <div className="mx-auto max-w-6xl px-4 sm:px-8 py-14 grid gap-10 md:grid-cols-3 items-start">
        <div>
          <span className="inline-flex rounded-2xl bg-[#f8f3e9] px-4 py-3 shadow-md">
            <img src="/logo-horizontal.png" alt="Little Splash Swim Program" className="h-9 w-auto" />
          </span>
        </div>
        <div data-testid="footer-location">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#e7b576]">
            <MapPin className="h-4 w-4" /> Where to find us
          </p>
          <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#f8f3e9]/80">
            Four Seasons Apartments Community Pool
            <br />
            3003 Woodland Ave, Des Moines, IA 50312
          </p>
        </div>
        <div data-testid="footer-hours">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#e7b576]">
            <CalendarCheck className="h-4 w-4" /> Getting started
          </p>
          <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#f8f3e9]/80">
            Free trial lessons — book online anytime
            <br />
            Fall 6-week mini session begins Monday, October 12
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-6xl px-4 sm:px-8 py-5 text-xs text-[#f8f3e9]/50">
          © 2026 Little Splash Swim Program · Proudly serving the families of Four Seasons Apartments, Des Moines, IA
        </p>
      </div>
    </footer>
  );
}
